import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=7b4d86c6&scoped=true"
var script = {}
import style0 from "./SaveIcon.vue?vue&type=style&index=0&id=7b4d86c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d86c6",
  null
  
)

export default component.exports